/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Plan_Day_CInputs */

const en_features_plan_day_c = /** @type {(inputs: Features_Plan_Day_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day C · Strength`)
};

const pl_features_plan_day_c = /** @type {(inputs: Features_Plan_Day_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień C · Siła`)
};

/**
* | output |
* | --- |
* | "Day C · Strength" |
*
* @param {Features_Plan_Day_CInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_plan_day_c = /** @type {((inputs?: Features_Plan_Day_CInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Plan_Day_CInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_plan_day_c(inputs)
	return en_features_plan_day_c(inputs)
});